import FD from "../views/RestAPI/fetchData";

const mobx = require('mobx');
import App_data from '../views/config/App_data'
import WebinarRESTService from "../services/WebinarRESTService";

const extendObservable = mobx.extendObservable;
const action = mobx.action;
const runInAction = mobx.runInAction;

function UserStore() {
    const self = this;

    extendObservable(this, {
        token: null,
        profileInfo: null,
        subscription_details: null,
        landingSource: null,
        landingSourceName: null,
        loading: false,
        error: null,
        apiVersion: null,
        isUserWebinarsAvailable: false,
    });

    this._profileFetchPromise = null;
    this._webinarsCountPromise = null;
    this._apiFetchPromise = null;

    this.setToken = action(function (token) {
        self.token = token;
    });

    this.setProfileInfo = action(function (profileInfo) {
        self.profileInfo = profileInfo;
    })

    this.clear = action(function () {
        self.token = null;
        self.profileInfo = null;
        self.error = null;
    });

    //Concurrent safe fetch profile info
    this.fetchProfile = action(async function (idname) {
        if (self._profileFetchPromise != null) {
            try {
                const resp = await self._profileFetchPromise;
                return resp && resp.success ? resp.profileInfo : null;
            } catch (e) {
                return null;
            }
        }

        self.loading = true;
        self.error = null;

        self._profileFetchPromise = FD.callAPI(
            App_data.backend_api + '/user/getProfileInfo',
            {
                token: self.token,
                idname: idname
            }
        );

        try {
            const resp = await self._profileFetchPromise;
            if (resp && resp.success) {
                runInAction(function () {
                    self.profileInfo = resp.profileInfo;
                    self.subscription_details = resp.subscription_details;
                    self.landingSource = resp.landingSource;
                    self.landingSourceName = resp.landingSourceName;
                    self.loading = false;
                });
                return resp.profileInfo;
            } else {
                runInAction(function () {
                    self.error = new Error('Profile request failed');
                    self.loading = false;
                });
                return null;
            }
        } catch (e) {
            runInAction(function () {
                self.error = e;
                self.loading = false;
            });
            return null;
        } finally {
            runInAction(function () {
                self._profileFetchPromise = null;
            });
        }
    });

    this.fetchApiVersion = action(async function () {
        try {
            const resp = await fetch(App_data.backend_api + '/version', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await resp.json();
            if (data != null) {
                runInAction(function () {
                    self.apiVersion = data;
                });
                return data;
            }
            return null;
        } catch (e) {
            console.warn(`Cannot get api version: ${e.message}`)
            return null;
        }
    })

    //Concurrent & state exist safe get profile info
    this.getUserProfile = action(async function (fullData = false) {
        if (self.profileInfo == null) {
            await self.fetchProfile();
        }
        if (fullData) {
            return {
                profileInfo: self.profileInfo,
                subscription_details: self.subscription_details,
                landingSource: self.landingSource,
                landingSourceName: self.landingSourceName,
            }
        }
        return self.profileInfo;
    });

    this.getSubscriptionDetails = action(async function () {
        //Check for profile info as main indicator data state
        if (self.profileInfo == null) {
            await self.fetchProfile();
        }
        return self.subscription_details;
    });

    this.getUsersLandingSource = action(async function () {
        if (self.profileInfo) {
            await self.fetchProfile();
        }
        return {
            landingSource: self.landingSource,
            landingSourceName: self.landingSourceName
        }
    })

    this.getUserWebinarsCount = action(async function (debug) {
        if (self._webinarsCountPromise != null) {
            try {
                const resp = await self._webinarsCountPromise;
                return resp && resp.count != null ? resp.count : 0;
            } catch (e) {
                return 0;
            }
        }
        self._webinarsCountPromise = new WebinarRESTService().setAuthHeader(self.token).getWebinarsCountByExam();
        try {
            const data = await self._webinarsCountPromise;
            if(data && data.count != null){
                runInAction(function () {
                    self.isUserWebinarsAvailable = data.count > 0;
                });
            }
            return data && data.count != null ? data.count : 0;
        } catch (e) {
            runInAction(function () {
                self.isUserWebinarsAvailable = false;
            });
            console.log("Error in getWebinarsCountByExam", e);
        }finally {
            runInAction(function () {
                self._webinarsCountPromise = null;
            });
        }
    })
}

//Debug Store
// mobx.spy(function (event) {
//     // event.type can be 'action', 'reaction', 'update' и т.д.
//     if (event.type === 'action') {
//         console.log(
//             '[MobX ACTION]',
//             event.name,
//             'args:',
//             event.arguments
//         );
//     }
//     if (event.type === 'reaction') {
//         console.log(
//             '[MobX REACTION]',
//             event.name
//         );
//     }
//     if (event.type === 'update') {
//         // will fire when a specific observable field has changed
//         console.log(
//             '[MobX UPDATE]',
//             event.object && event.object.constructor && event.object.constructor.name,
//             event.key,
//             '=>',
//             event.newValue
//         );
//     }
// });

export default new UserStore();



// WEBPACK FOOTER //
// ./src/store/userStore.js